import React from 'react';
import { toast } from 'react-toastify';
import BitaModal from '../../../../../bitaComponents/BitaModal/BitaModal';
import { ReactComponent as Logo } from '../../../../../static/img/Icons/BITA.svg';
import style from '../../../PortfolioBasketCalculation.module.scss';
import { coverageRequest } from '../../../utils/api';
import { buildRequestCoverageBody } from '../../../utils';
import { TYPE_OF_MODIFICATION } from '../../../utils/constants';

const styleClose = {
  position: 'absolute',
  fontSize: '30px',
  fontWeight: 'bold',
  top: '-10px',
  right: '0',
  cursor: 'pointer',
  padding: '10px',
  boxSizing: 'border-box',
};

const RequestCoverageModal = ({
  showModalRequestCoverage,
  setShowModalRequestCoverage,
  data,
  user,
  isUBSUser,
  setShowModalRequestCoverageSuccessful,
}) => {
  const handleRequestCoverageSubmit = () => {
    const allRequestCoverage = (data || []).flatMap(basket => {
      const basketBody = buildRequestCoverageBody({
        data: basket,
        user,
        withCoverageType: TYPE_OF_MODIFICATION.WITH_COVERAGE,
      });
      return basketBody?.request_coverage ?? [];
    });
    const body = {
      user_email: user?.userdata?.email,
      user_name: user?.username,
      company_name: user?.company,
      request_coverage: allRequestCoverage,
    };

    setShowModalRequestCoverage(false);
    coverageRequest(user.token, body)
      .then(rsp => {
        if (rsp.data.data.email_sent) {
          setShowModalRequestCoverageSuccessful(true);
        } else {
          toast.error('We had a problem processing your request');
        }
        setShowModalRequestCoverage(false);
      })
      .catch(error => {
        toast.error(error.response?.data?.error || 'We had a problem processing your request');
      });
  };
  return (
    <BitaModal
      isModalOpen={showModalRequestCoverage}
      setModalState={() => setShowModalRequestCoverage(false)}
    >
      <div style={{ width: '600px ', minHeight: '380px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #eee',
            padding: '10px 0',
          }}
        >
          <Logo style={{ width: '30px', height: '30px', marginRight: '20px' }} />
          <h2
            style={{
              margin: '0',
              padding: '0',
              fontSize: '20px',
              textTransform: 'uppercase',
              textAlign: 'center',
              marginLeft: '-20px',
              width: '100%',
            }}
          >
            REQUEST COVERAGE
          </h2>
          <span onClick={() => setShowModalRequestCoverage(false)} style={styleClose}>
            &times;
          </span>
        </div>
        <div>
          <div style={{ margin: '20px', textAlign: 'center' }}>
            We will send to the organization&apos;s e-mail the request for the following
            constituents
          </div>

          <div data-simplebar style={{ height: '360px' }}>
            <div style={{ width: '100%' }}>
              <div>Constituents</div>
              <div className={style.contentNoMetadata} style={{ width: '100%' }}>
                <div className={style.contentNoMetadata} style={{ width: '100%' }}>
                  <div className={style.tableNoMetadata}>
                    <div className={style.requestCoverageEntry}>
                      <div style={{ fontWeight: 'bold' }}>SYMBOL</div>
                      {isUBSUser && <div>SEDOL</div>}
                      <div>ISIN</div>
                      <div>MIC</div>
                    </div>
                    {(data || []).map((basket, idx) => {
                      const items = (basket?.meta_reference_data || []).filter(
                        item => item?.type !== TYPE_OF_MODIFICATION.WITH_COVERAGE,
                      );
                      return items.map((item, jdx) => (
                        <div
                          className={style.requestCoverageEntry}
                          key={`${basket.symbol || idx}-${item.isin || item.sedol || jdx}`}
                        >
                          <div>
                            {/* this allow to put the symbol of the basket in the first row */}
                            {jdx === 0 ? basket.symbol : ''}
                          </div>
                          {isUBSUser && <div>{item?.sedol ?? '-'}</div>}
                          <div>{item?.isin}</div>
                          <div>{item?.exchange}</div>
                        </div>
                      ));
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <button
              onClick={handleRequestCoverageSubmit}
              width="150px"
              height="30px"
              className="request-coverage-modal-button request-coverage-modal-button-blue"
              primary
              autoFocus
            >
              Submit
            </button>
            <button
              onClick={() => setShowModalRequestCoverage(false)}
              width="150px"
              height="30px"
              className="request-coverage-modal-button request-coverage-modal-button-white"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </BitaModal>
  );
};

export default RequestCoverageModal;
